<template>
  <div>
    <b-aspect aspect="16:9" class="w-100 h-100">
      <div class="image-aspect-ratio d-flex align-items-center">
        <b-img-lazy
          class="mh-100 mw-100 mx-auto"
          :src="jel_getFichierSrc(content.image)"
          :alt="content.altImage"
        />
      </div>
    </b-aspect>
    <div class="pt-2" v-html="content.titre" />
  </div>
</template>

<script>
export default {
  name: 'MediaImageApercu',
  props: {
    content: { type: Object, required: true },
  },
};
</script>

<style lang="scss" scoped>
.image-aspect-ratio {
  background-color: black;
  @supports (aspect-ratio: 16/9) {
    aspect-ratio: 16/9;
  }
  @supports not (aspect-ratio: 16/9) {
    height: 100%;
  }
}
::v-deep {
  p {
    font-size: 15px;
    line-height: 20px;
  }
}
</style>
